import { useState, useEffect } from 'react';

const WordCarousel = () => {
  const words = ['operations', 'financial', 'strategic', 'marketing'];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % words.length);
    }, 2000); // Change word every 2 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <span className="inline-block relative overflow-hidden align-top" style={{ height: '1.3em', lineHeight: '1em', paddingBottom: '0.3em' }}>
      <span 
        className="flex flex-col transition-transform duration-500 ease-in-out" 
        style={{
          transform: `translateY(-${currentIndex * 1.3}em)`
        }}
      >
        {words.map((word, index) => (
          <span 
            key={index} 
            className="block bg-gradient-to-r from-blue-600 via-indigo-600 to-blue-800 bg-clip-text text-transparent leading-none"
            style={{ height: '1.3em', lineHeight: '1em', paddingBottom: '0.3em' }}
          >
            {word}
          </span>
        ))}
      </span>
    </span>
  );
};

export default WordCarousel;
